// extracted by mini-css-extract-plugin
module.exports = {"windowWrapper":"app_windowWrapper__3E_YU","navbarWrapper":"app_navbarWrapper__3OAB4","contentWrapper":"app_contentWrapper__1MYHX"};